module.exports = __webpack_public_path__ + "static/media/cc.9569351d.svg";